module.exports = __webpack_public_path__ + "static/img/bubble.da38666.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bubble.gif
// module id = 57
// module chunks = 1